<template>
	<div v-if="!isLoading">

      <div class="tabs_wrapper">
          <div class="tab_item" :class="{ 'is_active': tab === 0 }" @click="tab = 0">
              Активные
          </div>
          <div class="tab_item" :class="{ 'is_active': tab === 1 }" @click="tab = 1">
              Архив
          </div>
      </div>

			<template v-if="tab === 0">
          <ul>
              <template v-for="pi in pis" :key="pi.id">
                  <li  v-if="!pi.isArchive">
                      <a :href="'/film_company/'+pi.user.id" target="_blank">{{ pi.user.firm_name }}</a> - <a @click="toArchive(pi)">В архив</a>
                  </li>
              </template>
          </ul>
			</template>
			<template v-else-if="tab === 1">
          <ul>
              <template v-for="pi in pis" :key="pi.id">
                  <li  v-if="pi.isArchive">
                      <a :href="'/film_company/'+pi.user.id" target="_blank">{{ pi.user.firm_name }}</a> - <a @click="fromArchive(pi)">Вернуть из архива</a>
                  </li>
              </template>
          </ul>
			</template>
	</div>
	<Spin v-else />
</template>

<script setup>
import {ref, computed} from "vue"
import axios from "axios"
import {Spin} from "ant-design-vue"

let pis = ref([]);
let isLoading = ref(false);
let tab = ref(0);

async function getData() {
	isLoading.value = true;
	//const response = await axios.get('/api/projects_infos?competition.id=' + window.competitionId);
  const response = await axios.get('/get_pis_by_competition_id/' + window.competitionId);
	pis.value = response.data;
	isLoading.value = false;
}
getData();

const competitionId = computed(() => {
  return window.competitionId;
})

async function toArchive(pi) {
  isLoading.value = true;
  await axios.patch('/api/projects_infos/' + pi.id, {'isArchive': true}, {
    headers: {
      'Content-Type': "application/merge-patch+json"
    }
  }).catch((event) => {
    alert(event.response.data['hydra:description']);
  });
	await getData();
}

async function fromArchive(pi) {
  isLoading.value = true;
  await axios.patch('/api/projects_infos/' + pi.id, {'isArchive': false}, {
    headers: {
      'Content-Type': "application/merge-patch+json"
    }
  }).catch((event) => {
    alert(event.response.data['hydra:description']);
  });
  await getData();
}

</script>

<style scoped>

</style>